<template>
  <div class="sign-in-layout">
    <div class="left-panel">
      <img src="images/inicio2.jpg" alt="marca" class="brand-big" />
    </div>

    <div class="right-panel">
      <div class="form-wrap">
        <img src="images/logo_blanco.png" alt="Logo" class="header-logo" />

        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
          :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="Usuario" :colon="false">
            <div class="input-with-icon">
              <a-input
                v-decorator="['email', { rules: [{ required: true, message: 'Digita un usuario!' }] }]"
                placeholder="Usuario"
                class="pill-input"
              />
            </div>
          </a-form-item>

          <a-form-item class="mb-5" label="Clave" :colon="false">
            <div class="input-with-icon">
              <a-input
                v-decorator="['password', { rules: [{ required: true, message: 'Digita tu password!' }] }]"
                type="password"
                placeholder="Clave"
                class="pill-input"
              />
            </div>
          </a-form-item>

          <a-form-item>
            
            <template v-if="!submitting">
              <a-button type="primary" block html-type="submit" class="login-btn">
                INICIAR SESION
              </a-button>
            </template>
            <div v-else class="text-center" style="padding-top:4px;">
              <a-spin size="small" />
            </div>
          </a-form-item>

          <div class="text-center mb-3">
            <!-- <router-link to="/recuperar-clave" class="forgot-link">¿Olvidaste tu contraseña?</router-link> -->
          </div>

          <img class="brand-small" src="images/LOGO.png" alt="logo" />
        </a-form>
        <a-row type="flex" :gutter="[24,24]" justify="space-around">
          <a-col :span="24" class="col-form text-center">
            
            <a-alert :message="authError" v-if="authError" type="error" show-icon />
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/helpers/auth';
export default {
  data() {
    return {
      submitting: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.$store.commit('authError');
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true;
          this.$store.dispatch('login');
          login(values)
            .then((res) => {
              if (res.status !== 'Success') {
                const err = res.errors.length > 0 ? res.errors[0] : 'error desconocido';
                this.$store.commit('loginFail', { err });
              } else {
                this.$store.commit('loginSuccess', res);
                this.redirect(res);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$store.commit('loginFail', { err });
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },
    redirect(res) {
      this.$router.push('/inicio');
    }
  },
  computed: {
    authError() {
      return this.$store.getters.auth_error;
    },
    loading() {
      return this.$store.getters.isLoading;
    }
  }
};
</script>

<style scoped>
/* Layout */
.sign-in-layout {
  display: grid;
  grid-template-columns: 62% 38%;
  min-height: 100vh;
  background: #6f7b84;
  align-items: stretch;
  overflow: hidden; /* mantiene la página sin scroll inesperado */
}

/* Left panel: usar clip-path para crear la curva de separación.
   Clip-path recorta el panel sin crear pseudo-elementos grandes que provoquen scroll. */
.left-panel {
  position: relative;
  overflow: hidden;
  background: #4f5a62;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  /* curva más pronunciada mirando hacia la derecha */
  -webkit-clip-path: ellipse(75% 75% at 18% 50%);
  clip-path: ellipse(75% 75% at 18% 50%);
}

/* Imagen grande: ajustar para que no quede cortada con la curva más pronunciada */
.brand-big {
  width: 120%;
  max-width: none;
  height: 100vh;
  object-fit: cover;
   /* desplazar más para centrar la parte visible */
  position: relative;
  z-index: 0;
}

/* Right panel */
.right-panel {
  position: relative;
  z-index: 3; /* encima del left-panel recortado */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  background: transparent;
}

/* wrapper del formulario: limitar ancho para que no parezca saturado */
.form-wrap {
  width: 100%;
  max-width: 360px;
  padding: 0.75rem 1rem 2rem;
  color: #fff;
}

/* Logo del header */
.header-logo {
  display: block;
  margin: 0 auto 1.5rem;
  height: 120px;
  width: auto;
  opacity: 0.95;
}

/* resto de estilos existentes (inputs, botones, logo pequeño, etc.) */
.subtitle {
  color: rgba(255,255,255,0.95);
  font-weight: 500;
  margin-bottom: 1.25rem;
}
.input-with-icon { position: relative; }
.pill-input .ant-input {
  border-radius: 999px !important;
  height: 44px;
  padding-left: 48px !important;
  background: rgba(255,255,255,0.95);
  border: none;
  box-shadow: none;
  color: #2b3a3f;
}
.pill-input .ant-input::placeholder { color: rgba(43,58,63,0.45); }

/* icon pseudo-elements */
.input-with-icon::before {
  content: "";
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.85;
}
.input-with-icon:nth-of-type(1)::before {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='%23323b3f' viewBox='0 0 24 24'><path d='M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.2c-3.3 0-9.9 1.7-9.9 5v1.7h19.8V19c0-3.3-6.6-5-9.9-5z'/></svg>");
}
.input-with-icon:nth-of-type(2)::before {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='%23323b3f' viewBox='0 0 24 24'><path d='M17 8V7a5 5 0 10-10 0v1H5v12h14V8h-2zM9 7a3 3 0 116 0v1H9V7z'/></svg>");
}

.login-btn {
  border-radius: 999px;
  height: 44px;
  background: #213040;
  border: none;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(33,48,64,0.18);
}
.login-btn:hover, .login-btn:focus { background: #1a2732; color: #fff; }

.brand-small {
  display: block;
  margin: 1.5rem auto 0;
  width: 260px;
  max-width: 90%;
  height: auto;
  opacity: 0.95;
}

.forgot-link { color: rgba(255,255,255,0.85); text-decoration: underline; }
.mb-10 { margin-bottom: 10px; }
.mb-5 { margin-bottom: 8px; }
.text-center { text-align: center; }

/* Responsive: ocultar panel izquierdo y la curva en pantallas pequeñas */
@media (max-width: 992px) {
  .sign-in-layout { grid-template-columns: 1fr; }
  .left-panel { display: none; }
  .right-panel { padding: 2.5rem 1rem; }
  .form-wrap { max-width: 520px; margin: 0 auto; }
}
</style>